import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-button normal bg-purple circle-purple",on:{"click":function($event){return _vm.downloadFile(_vm.link)}}},[_c('div',{staticClass:"bg"}),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"circle"},[_c(VIcon,[_vm._v("mdi-download")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }